import get, { privateGet } from "../../methods/get";
import { IObterListaComarca, IObterListaUF, IObterListaComarcaUF } from '../../models/Comarca/index';

export const obterListaComarca = (sigla: IObterListaComarcaUF) => {
    return privateGet<IObterListaComarca>("/comarca/obterlistacomarca", sigla)
}

export const obterListaUF = () => {
    return privateGet<IObterListaUF>("/comarca/obterlistauf")
}